import { Box } from '@mui/material';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Caption, Theme } from '@routific/hive';
import DriverAutocomplete from './DriverAutocomplete';
import { DriverDtoModelType } from '../../../store/mst/models';

interface Props {
  drivers: Array<DriverDtoModelType>;
  control: Control<FieldValues, any>;
}

const DriverSelector: React.FC<Props> = ({ drivers, control }) => {
  const { t } = useTranslation('components');

  return (
    <>
      <Box display="flex" sx={{ paddingBottom: Theme.Spacing.xsSpacing }}>
        <Caption>{t('insights.filter.drivers.label')}</Caption>
      </Box>
      <form onSubmit={(e) => e.preventDefault()}>
        <Controller
          name="driverSelector"
          control={control}
          render={({ field }) => (
            <DriverAutocomplete
              drivers={drivers}
              value={field.value ?? []}
              onChange={field.onChange}
            />
          )}
        />
      </form>
    </>
  );
};

export default DriverSelector;
